import { Component } from '@angular/core';

@Component({
  selector: 'app-financial-service',
  templateUrl: './financial-service.component.html',
  styleUrl: './financial-service.component.scss'
})
export class FinancialServiceComponent {

}
